var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2133 14.4937C16.08 14.4803 15.92 14.4803 15.7733 14.4937C12.6 14.387 10.08 11.787 10.08 8.58699C10.08 5.32033 12.72 2.66699 16 2.66699C19.2666 2.66699 21.92 5.32033 21.92 8.58699C21.9066 11.787 19.3866 14.387 16.2133 14.4937Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54695 19.413C6.32029 21.573 6.32029 25.093 9.54695 27.2397C13.2136 29.693 19.227 29.693 22.8936 27.2397C26.1203 25.0797 26.1203 21.5597 22.8936 19.413C19.2403 16.973 13.227 16.973 9.54695 19.413Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.cd8811928a48f7a1e88cab7adeeeae16.svg";
export { ForwardRef as ReactComponent };